module.exports = __webpack_public_path__ + "img/takeda-group.defac17.png";